<template>
  <div>
     <van-notice-bar
      scrollable
      v-if="showNotice"
      left-icon="volume-o"
      text="云时空将于5月29日-30日全员团建，期间客服响应或有延迟。紧急问题请标注'紧急'级别，我们将优先处理。感谢您的理解与配合！ 云时空将于5月29日-30日全员团建，期间客服响应或有延迟。紧急问题请标注'紧急'级别，我们将优先处理。感谢您的理解与配合！"
    >
    </van-notice-bar>
    <van-notice-bar
      color="#000"
      background="#ecf9ff"
    >
    <div @click="gotocenter">
      <van-icon name="manager-o" size="16px"/>
      <span>
        {{userinfo.nickName}}
      </span>
    </div>
      <slot slot="right-icon" name="right">
        <div @click="gotohis">
          <span class="tip-blue" >
            查看历史工单
          </span>
          <van-icon name="arrow" color="#004099"/>
        </div>
      </slot>
    </van-notice-bar>
    <div class="text_label" v-if="showTitle" @click="gotohis">
      您有工单未关闭/评价
    </div>
    <van-cell :title="item.val" is-link v-for="(item,index) in list" :key="index" @click="gotocreate(item)"/>
  </div>
</template>

<script>
import { NoticeBar,Icon,Cell,Toast } from 'vant';
import { Dialog } from 'vant';


import { mapState } from 'vuex'
  export default {
    computed: {
      ...mapState({
      'userinfo': state=>state.user.userinfo
      })
    },
    components : {
      [NoticeBar.name]:NoticeBar,
      [Cell.name]:Cell,
      [Icon.name]:Icon,
      [Toast.name]:Toast,
      [Dialog.name]:Dialog
    },
    data(){
      return {
        list:[],
        showInfo:false,
        days:0,
        label:'',
        showNotice:false,
        showTitle:false
      }
    },
    mounted(){
      // this.findSolveList()
      this._remindDays()
      this.findUserServiceDate()
      this.findProject()
      console.log(this.getToday())
      if(this.getToday()=="2026-05-28"||this.getToday()=="2026-05-29"||this.getToday()=="2026-05-30"){
        this.showNotice = true
      }else{
        this.showNotice = false
      }
      setTimeout(() => {
        this._evaTips()
      }, 2000);
       
      if((!this.$route.query.code || this.$route.query.code == '' || typeof(this.$route.query.code)=="undefined") && (this.$route.query.openid=="" || this.$route.query.openid==null || typeof(this.$route.query.openid)=="undefined")){ 
          var appid = 'wx04af1f8f73fb48cd'
          var local = 'http://m.kefu.ysk360.com/feedback'
          // var appid = 'wxf686e8ab7875b150'
          // var local = 'http://o430126k44.qicp.vip.vaiwan.com/feedback'
          var url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+appid+'&redirect_uri='+ encodeURIComponent(local)+'?type=logins&response_type=code&scope=snsapi_base&state=123#wechat_redirect' 
          window.location.href = url 
      }else{
          this.updateopenid()
      }

    },
    methods : {
      getToday() {
        let date = new Date();
        let year = date.getFullYear();
        let month = (date.getMonth() + 1).toString().padStart(2, '0');
        let day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
      },
      gotohis(){
        if(this.showInfo){
           this.$router.push({
            path : '/pending'
          })
        }else{
          this.$router.push({
            path : '/historylist'
         })
        }
      },
      async updateopenid(){
        const res = await this.$http.get(`/mobile/user/updateOpenId`,{params:{userId:this.userinfo.userId,code:this.$route.query.code},headers: { Authorization: "Bearer " + this.$cookies.get('token')}}).then((data)=> data.data)

      },
      async findSolveList(){
         const res = await this.$http.get(`/business/workOrder/waitEvaluation/list`,{headers: { Authorization: "Bearer " + this.$cookies.get('token')}}).then((data)=> data.data)
         console.log(res)
         if(res.rows!=''){
           this.showInfo=true
         }else{
           this.showInfo=false
         }
      },
      nowDate(){
            var now = new Date();
            var year = now.getFullYear(); //得到年份
            var month = now.getMonth();//得到月份
            var date = now.getDate();//得到日期
            var hour = now.getHours();//得到小时
            var minu = now.getMinutes();//得到分钟
            var sec = now.getSeconds();//得到秒
            month = month + 1;
            if (month < 10) month = "0" + month;
            if (date < 10) date = "0" + date;
            if (hour < 10) hour = "0" + hour;
            if (minu < 10) minu = "0" + minu;
            if(sec<10) sec = "0"+sec
            return year+'-'+month+'-'+date;
        },
      getDaysBetween(dateString1,dateString2){
            var  startDate = Date.parse(dateString1);
            var  endDate = Date.parse(dateString2);
            if (startDate>endDate){
                return 0;
            }
            if (startDate==endDate){
                return 1;
            }
            var days=(endDate - startDate)/(1*24*60*60*1000);
            return  days;
      },
      async _evaTips () {
        const res = await this.$http.get(`/mobile/evaTips`,{headers: { Authorization: "Bearer " + this.$cookies.get('token')}}).then((data)=> data.data)
        // console.log(res)
        if (res.code == 200) {
          // console.log(res)
          if (parseInt(res.msg) > 0) {
            // this.label = res.msg
            this.showTitle = true
          }
        }
      },
      async _remindDays () {
        const res = await this.$http.get(`/mobile/configKey/remindDays`,{headers: { Authorization: "Bearer " + this.$cookies.get('token')}}).then((data)=> data.data)
        // console.log(res)
        if (res.code == 200) {
          this.days = res.msg
        }
      },
      async findUserServiceDate(){
        var _this = this
        const res = await this.$http.get(`/system/user/getUserServiceDate`,{params:{userId:this.userinfo.userId},headers: { Authorization: "Bearer " + this.$cookies.get('token')}}).then((data)=> data.data)
        if(res.code==200){
          var day =  this.getDaysBetween(this.nowDate(),res.serviceDate)
          // console.log(day)
          // console.log(this.days)
          if(day<1){
            Dialog.alert({
              title: '标题',
              message: '您的账号已过期，续费后才能使用',
            }).then(() => {
              _this.$cookies.set('token', '')
              _this.$router.push({
                  path : '/login'
                })
            });
            // day<=7
          }else if(day<=this.days){
             if(res.status==1){
                Dialog.alert({
                    title: '标题',
                    message: '您的账号已停用，请联系管理员',
                  }).then(() => {
                    _this.$cookies.set('token', '')
                    _this.$router.push({
                        path : '/login'
                      })
                  });
            }else{
              Dialog.alert({
                title: '标题',
                message: '您的账号还有'+day+'天到期，请及时续费！',
              }).then(() => {
                // on close
              });
            }
           
          }else if(res.status==1){
               Dialog.alert({
                  title: '标题',
                  message: '您的账号已停用，请联系管理员',
                }).then(() => {
                  _this.$cookies.set('token', '')
                  _this.$router.push({
                      path : '/login'
                    })
                });
          }
        }
     },
      findProject(){
        var _this = this
        this.$http.get(`/business/workOrder/projectList`,{headers: { Authorization: "Bearer " + this.$cookies.get('token')}}).then(function(res){
          if(res.data.code==200){
            _this.list = res.data.rows
          }else if(res.data.code==401){
            _this.$cookies.set('token', '')
            Toast("您的登录已过期，请重新登录")
            setTimeout(function(){
              _this.$router.push({
                path : '/login'
              })
            },1000)
          }
        })
       
      },
      gotocreate(item){
        // if(this.showInfo==false){
        // }else{
        //    Toast("您有没处理完的工单，处理完才能创建新的工单")
        // }
        this.$router.push({
          path : `/createsheet/${item.id}`,
          query:{stat:item.stat}
        })
       
      },
      gotocenter(){
        this.$router.push({
          path : '/personalcenter'
        })
      }
    }
  }
</script>

<style scoped>
.tip-blue{
  color : #004099;
}
.text_label {
  padding: 10px 16px;
  box-sizing:boredr-box;
  font-size:14px;
  border-bottom:1px solid #ccc;
}
.text_label span {
  color : #004099;
  margin: 0 2px;
}
</style>



// WEBPACK FOOTER //
// src/pages/feedback/index.vue